import { ShipNodeTab } from '@skupreme/shared/components/shipnode';
import { EmptyState } from '@skupreme/shared/ui';
import { useMemo } from 'react';
import { createWarehouseShipNodeService } from '../../../utility/services/shipnode';
import { shipNodeChannel } from '../../../utility/shipnode/channel';

/**
 * WMS Settings › ShipNode (EN-3277): the shared ShipNode tab over the current warehouse's stations. Every WMS
 * user of the warehouse's organization may add, remove and use stations (Ely, 2026-09-29: no role gate).
 */
export function ShipNodeSettingsTab({ warehouseId }: { warehouseId?: string }) {
  /* A new warehouse means a new service, which makes the tab reload that warehouse's stations. */
  const service = useMemo(
    () => (warehouseId ? createWarehouseShipNodeService(warehouseId) : null),
    [warehouseId],
  );

  if (!service) {
    return (
      <EmptyState
        title="No warehouse selected"
        description="Pick a warehouse to see its ShipNode stations."
      />
    );
  }

  return <ShipNodeTab service={service} channel={shipNodeChannel()} canManage canUse />;
}
